var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8538 27.5972H32.5167L24.8841 14.4111L22.0938 19.0222L24.2389 22.8813L26.8538 27.5972Z",
    fill: "#3C10EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9671 33.7957L9.78133 30.048C9.57381 29.6922 9.57283 29.2544 9.77877 28.8977L15.5305 18.9351L20.4267 10.2204C20.8729 9.42625 22.0294 9.42659 22.4751 10.221L24.5743 13.9627C24.7787 14.327 24.769 14.7717 24.549 15.1269L22.7723 17.9957L14.0087 33.7746C13.5694 34.5656 12.4231 34.5775 11.9671 33.7957Z",
    fill: "#B6C4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1027 27.5972H32.4935L34.222 30.6131C34.6638 31.3842 34.0999 32.3395 33.2027 32.3395H20.7978C19.9067 32.3395 19.3421 31.3957 19.772 30.6249L21.1264 28.1959C21.3324 27.8265 21.7254 27.5972 22.1522 27.5972H28.1027Z",
    fill: "#2CA4FE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngle);
export default __webpack_public_path__ + "static/media/angle.57c9136b910a0e420fadc66733bfb357.svg";
export { ForwardRef as ReactComponent };